import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "@/lib/cart";

const NAV = [
    { to: "/boutique", label: "Boutique" },
    { to: "/boutique/chaines", label: "Chaînes" },
    { to: "/boutique/pendentifs", label: "Pendentifs" },
    { to: "/boutique/bracelets", label: "Bracelets" },
    { to: "/boutique/boucles", label: "Boucles d'oreille" },
    { to: "/authenticite", label: "Authenticité GRA" },
    { to: "/suivi", label: "Suivi" },
];

export default function Header() {
    const { count, setOpen } = useCart();
    const [mobile, setMobile] = useState(false);
    const navigate = useNavigate();

    return (
        <>
            <div className="bg-[#0B192C] text-center text-[11px] tracking-[0.2em] uppercase text-slate-300 py-2 px-4" data-testid="free-shipping-banner">
                Livraison gratuite dès 500 $ CAD · Postes Canada
            </div>
            <header className="glass-header sticky top-0 z-40">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between h-16">
                    <button
                        data-testid="mobile-menu-btn"
                        className="md:hidden p-2 -ml-2"
                        onClick={() => setMobile(true)}
                        aria-label="Menu"
                    >
                        <Menu className="w-6 h-6 text-slate-200" />
                    </button>
                    <Link to="/" data-testid="brand-logo" className="flex items-center gap-3">
                        <div className="font-serif-luxe text-xl sm:text-2xl tracking-[0.2em] chrome-text font-semibold">
                            VVS HÉRITAGE
                        </div>
                    </Link>
                    <nav className="hidden md:flex items-center gap-8">
                        {NAV.map((n) => (
                            <Link
                                key={n.to}
                                to={n.to}
                                data-testid={`nav-${n.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                                className="text-[11px] uppercase tracking-[0.18em] text-slate-300 hover:text-white transition-colors"
                            >
                                {n.label}
                            </Link>
                        ))}
                    </nav>
                    <button
                        data-testid="cart-open-btn"
                        onClick={() => setOpen(true)}
                        className="relative p-2 -mr-2"
                        aria-label="Panier"
                    >
                        <ShoppingBag className="w-6 h-6 text-slate-200" />
                        {count > 0 && (
                            <span data-testid="cart-count" className="absolute -top-1 -right-1 bg-white text-black text-[10px] font-bold w-5 h-5 rounded-full flex items-center justify-center">
                                {count}
                            </span>
                        )}
                    </button>
                </div>
            </header>

            {mobile && (
                <div className="fixed inset-0 z-50 md:hidden" data-testid="mobile-menu">
                    <div className="absolute inset-0 bg-black/70" onClick={() => setMobile(false)} />
                    <div className="absolute left-0 top-0 bottom-0 w-80 bg-[#121216] border-r border-white/10 p-6 flex flex-col gap-2">
                        <div className="flex items-center justify-between mb-6">
                            <div className="font-serif-luxe text-lg tracking-[0.2em] chrome-text">VVS HÉRITAGE</div>
                            <button data-testid="mobile-menu-close" onClick={() => setMobile(false)} aria-label="Fermer">
                                <X className="w-6 h-6 text-slate-300" />
                            </button>
                        </div>
                        {NAV.map((n) => (
                            <button
                                key={n.to}
                                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                                onClick={() => { setMobile(false); navigate(n.to); }}
                                className="text-left py-3 text-sm uppercase tracking-[0.15em] text-slate-200 border-b border-white/5"
                            >
                                {n.label}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </>
    );
}
